<template>
  <sj-layout-logo>
    <template v-slot:default>
      <div ref="text"
           style="font-size: 22px;letter-spacing: 2px;white-space: nowrap;opacity: 0;">{{ text }}
      </div>
    </template>
    <template v-slot:collapse>
      <span style="font-size: 22px;">{{ text[0] }}</span>
    </template>
  </sj-layout-logo>
</template>

<script>
import SjLayoutLogo from './LayoutLogo'

export default {
  name: 'AsideLogo',
  components: {
    SjLayoutLogo,
  },
  props: {
    value: String,
  },
  data () {
    return {}
  },
  computed: {
    text () {
      return this.value
    },
  },
  watch: {
    value () {
      this.scaleText()
    },
  },
  created () {
  },
  mounted () {
    this.scaleText()
  },
  methods: {
    scaleText () {
      const textEl = this.$refs.text
      textEl.style.opacity = '0'
      textEl.style.transform = 'scale(1)'
      textEl.style.position = 'fixed'
      this.$nextTick(() => {
        const containerWidth = this.$el.clientWidth - 12
        if (textEl.clientWidth > containerWidth) {
          const scaleValue = containerWidth / textEl.clientWidth
          textEl.style.transform = `scale(${scaleValue})`
        }
        textEl.style.opacity = '1'
        textEl.style.position = 'static'
      })
    },
  },
}
</script>

<style lang="scss">

</style>
